export const ILLUSTRATION_CONSTANTS = {
  SUCCESS: "/media/illustrations/success.svg",
  SUCCESS_FAILED_HARVEST: "/media/illustrations/success_failed_harvest.svg",
  FAIL: "/media/illustrations/Illustration_delete_propose.svg",
  EMPTY: "/media/illustrations/farmer_lahan.svg",
  PLANTING_SUCCESS: "/media/illustrations/planting_date_added.svg",
  AREA_SUCCESS: "/media/illustrations/lahan_success.svg",
  AREA_REJECT: "/media/illustrations/lahan_reject.svg",
  BROADCAST_SUCCESS_DELETE: "/media/illustrations/order_success.svg",
  BROADCAST_SUCCESS_CREATE: "/media/illustrations/support_sent.svg",
  ILLUSTRATION_SUCCESS: "/media/illustrations/Ilustrasi_success.svg",
  ORDER_SUCCESS: "/media/illustrations/order_success.svg",
  FARMER_REJECTED: "/media/illustrations/farmer_rejected.svg",
  SUCCESS_PLACEHOLDER: "/media/illustrations/success_placeholder.svg",
  SUCCESS_PLACEHOLDER_LOCATION: "/media/illustrations/succss_placeholder_location.svg",
  SUCCESS_PLACEHOLDER_PLANT: "/media/illustrations/success_placeholder_plant.svg",
  SUCCESS_PLACEHOLDER_ORDER: "/media/illustrations/success_placeholder_order.svg",
  SUCCESS_ILLUSTRATION: "/media/illustrations/Ilustrasi_success.svg",
  CHANGE_ORDER: "/media/illustrations/change_order.svg",
  SUCCESS_FORM: "/media/illustrations/success_form.svg",
  FO_CREATED: "/media/illustrations/fo_created.svg",
  SUCCESS_PLANTING_SEASON_CONFIRMATION: "/media/illustrations/planting_season_confirmation.svg",
  SUCCESS_OPS_TEAM_EDIT: "/media/illustrations/success_ops_team_edit.svg",
  //FROM ILLUSTRATION_ASSETS_V2
  EMPTY_STATE: "/media/illustrations/empty_state.desktop.svg",
  SEARCH_NO_DATA: "/media/illustrations/empty_state_search_not_found.svg",
  EMPTY_STATE_NO_DATA: "/media/illustrations/empty_state_no_data.svg",
  EMPTY_STATE_FARMER: "/media/illustrations/empty_state_farmer.svg",
  SEARCH_EMPTY_STATE: "/media/illustrations/search_empty_state.svg",
  NOT_FOUND_FARMER: "/media/illustrations/not_found_farmer.svg",
  POSITIVE_DIPERBARUI: "/media/illustrations/positive_diperbarui.svg",
  SUCCESS_DELETE: "/media/illustrations/success_delete.svg",
  NOT_FOUND_REGIONAL: "/media/illustrations/not_found_regional.svg",
  SUCCESS_ADD: "/media/illustrations/success_tambah.svg",
  POSITIVE_ADD: "/media/illustrations/positive_add.svg",
  POSITIVE_CONFIRM_PLANTING_SEASON: "/media/illustrations/positive_konfirmasi_musim_tanam.svg",
  NOT_FOUND_DESKTOP: "/media/illustrations/not_found_desktop.svg",
  EMPTY_STATE_DESKTOP: "/media/illustrations/empty_state_desktop.svg",
  EMPTY_DESKTOP: "/media/illustrations/empty_desktop.svg",
  EMPTY_STATE_DATA: "/media/illustrations/empty_state_data.svg",
  NOT_FOUND_DATA: "/media/illustrations/not_found_data.svg",
  SUCCESS_CREATE_SUBMISSION: "/media/illustrations/success_create_submission.svg",
  DIRECTION: "/media/illustrations/direction.png",
  SUCCESS_ASSIGN_GENERAL: "/media/illustrations/success_assign_general.svg",
  SUCCESS_SETTING_TARGET: "/media/illustrations/success_setting_target.svg",
  SUCCESS_CANCEL_SCHEDULE: "/media/illustrations/success_cancel_schedule.svg",
  SUCCESS_EDIT_SCHEDULE: "/media/illustrations/success_edit_schedule.svg",
  SUCCESS_FREEZE_AREA: "/media/illustrations/success_freeze_area.svg",
  SUCCESS_BLACKLIST_AREA: "/media/illustrations/success_blacklist_area.svg",
  SUCCESS_UNFREEZE_AREA: "/media/illustrations/success_unfreeze_area.svg",
  SUCCESS_FREEZE_MITRA: "/media/illustrations/success_freeze_mitra.svg",
  SUCCESS_BLACKLIST_MITRA: "/media/illustrations/success_blacklist_mitra.svg",
  SUCCESS_UNFREEZE_MITRA: "/media/illustrations/success_unfreeze_mitra.svg",
  SUCCESS_FREEZE_FARMER: "/media/illustrations/success_freeze_farmer.svg",
  SUCCESS_BLACKLIST_FARMER: "/media/illustrations/success_blacklist_farmer.svg",
  SUCCESS_UNFREEZE_FARMER: "/media/illustrations/success_unfreeze_farmer.svg",
  FARMER: {
    EMPTY_STATE: "/media/illustrations/farmer/Empty_State_Desktop.svg",
    EMPTY_STATE_NO_DATA: "/media/illustrations/farmer/empty_desktop_tidak_ada_data_petani.svg",
    EMPTY_STATE_NO_DATA_AREA: "/media/illustrations/farmer/empty_tidak_ada_data_lahan.svg",
    FAILED_SEND_ERP: "/media/illustrations/farmer/negative_send_to_ERP.svg",
    SUCCESS_SEND_ERP: "/media/illustrations/farmer/positive_send_to_ERP.svg",
    SUCCESS_CHANGE_MITRA: "/media/illustrations/farmer/Positive_mitra_diganti.svg",
    INVALID_CHANGE_STATUS: "/media/illustrations/farmer/Positive_Petani_tidak_dapat_diganti.svg",
    SUCCESS_FARMER_NONACTIVE:
      "/media/illustrations/farmer/Positive_Petani_berhasil_dinontaktifkan.svg",
    SUCCESS_REJECT: "/media/illustrations/farmer/Positive_petani_berhasil_ditolak.svg",
    SUCCESS_APPROVE: "/media/illustrations/farmer/Positive_petani_berhasil_diverifikasi.svg",
    CANNOT_CHANGE: "/media/illustrations/farmer/Positive_Petani_tidak_dapat_diganti.svg",
    SUCCESS_UPDATED: "/media/illustrations/farmer/Positive_petani_diperbarui.svg",
    SUCCESS_CREATED: "/media/illustrations/farmer/Positive_petani_ditambah.svg",
    SUCCESS_CREATE_REPORT: "/media/illustrations/farmer/Positive_laporan_berhasil_dibuat.svg"
  },
  MITRA: {
    EMPTY_STATE: "/media/illustrations/mitra/Empty_State_mitra.svg",
    EMPTY_STATE_NO_DATA: "/media/illustrations/mitra/empty_desktop_tidak_ada_data_mitra.svg",
    FAILED_SEND_ERP: "/media/illustrations/mitra/negative_send_to_ERP.svg",
    SUCCESS_SEND_ERP: "/media/illustrations/mitra/positive_send_to_ERP.svg",
    EMPTY_STATE_LOG: "/media/illustrations/mitra/empty_belum_ada_log.svg",
    EMPTY_STATE_LOG_NO_DATA: "/media/illustrations/mitra/empty_pencarian_riwayat_log.svg",
    SUCCES_MITRA_NONACTIVE: "/media/illustrations/mitra/Positive_Mitra_berhasil_dinontaktifkan.svg",
    SUCCESS_REJECT: "/media/illustrations/mitra/Positive_mitra_berhasil_ditolak.svg",
    SUCCESS_APPROVE: "/media/illustrations/mitra/Positive_mitra_berhasil_diverifikasi.svg",
    CANNOT_CHANGE: "/media/illustrations/mitra/Positive_MItra_tidak_dapat_diganti.svg",
    SUCCESS_UPDATED: "/media/illustrations/mitra/Positive_MItra_diperbarui.svg",
    SUCCESS_CREATED: "/media/illustrations/mitra/Positive_mitra_ditambah.svg"
  }
}

export const ICON_CONSTANTS = {
  CHECKLIST: "/media/icons/checklist.svg",
  LOADING_FORECAST: "/media/icons/loading_forecast.svg",
  DOWNLOAD_CLOUD: "/media/icons/download_cloud.svg",
  TASK_WHITE: "/media/icons/task_white.svg",
  FIELD: "/media/icons/field.svg",
  FIELD_BIG: "/media/icons/field_big.svg",
  FIELD_2: "/media/icons/field_2.svg",
  FARMER: "/media/icons/farmer.svg",
  HARVEST: "/media/icons/harvest.svg",
  VEGETATIVE: "/media/icons/vegetative.svg",
  SOIL: "/media/icons/soil.svg",
  SOIL_ALT: "/media/icons/soil_alt.svg",
  MAIL: "/media/icons/mail.svg",
  ANGLE_ARROW: "/media/icons/angle_arrow.svg",
  FARMER_GRAY: "/media/icons/farmer_gray.svg",
  MAP_GRAY: "/media/icons/map_gray.svg",
  PADDY_GRAY: "/media/icons/paddy_gray.svg",
  CORN_GRAY: "/media/icons/corn.svg",
  PLANTING_GRAY: "/media/icons/planting_gray.svg",
  ORDER_ALL: "/media/icons/task_alt.svg",
  ORDER_PASCA_PLANTING: "/media/icons/pra_tanam.svg",
  TASK: "/media/icons/task.svg",
  ORDER_APPROVED: "/media/icons/bullet_tick_order.svg",
  ORDER_PENDING: "/media/icons/clock.svg",
  ORDER_RESCHEDULE: "/media/icons/reschedule.svg",
  INFORMATION: "/media/icons/information.svg",
  EDIT: "/media/icons/action/edit.svg",
  EDIT_BLACK: "/media/icons/action/edit_black.svg",
  INFO_REGION: "/media/icons/information.svg",
  FO: "/media/icons/side-menu/field_officer.svg",
  REGIONAL_HEAD: "/media/icons/side-menu/regional_head.svg",
  FIELD_MANAGER: "/media/icons/side-menu/field_manager.svg",
  FO_QA: "/media/icons/side-menu/field_officer_qa.svg",
  FIELD_SUPERVISOR: "/media/icons/side-menu/field_supervisor.svg",
  AGRONOMIST_DRONE_SPV: "/media/icons/side-menu/agronomist_drone_spv.svg",
  HARVEST_SPV: "/media/icons/side-menu/harvest_spv.svg",
  OPERATIONS_TEAM: "/media/icons/side-menu/operations_team.svg",
  ROUNDED_FIELD: "/media/icons/rounded_field.svg",
  PLUS: "/media/icons/plus_on.svg",
  PLUS_PRIMARY: "/media/icons/plus.svg",
  ROUNDED_MAP_PIN: "/media/icons/rounded_field.svg",
  ROUNDED_LOCATION: "/media/icons/rounded_location.svg",
  ROUNDED_AREA: "/media/icons/rounded_area.svg",
  ROUNDED_PLANT_SPRAYING: "/media/icons/rounded_plant_spraying.svg",
  BULLET_TICK: "/media/icons/bullet_tick.svg",
  BULLET_TICK_BIG: "/media/icons/bullet_tick_big.svg",
  BULLET_CLOSE: "/media/icons/bullet_close.svg",
  BULLET_CLOSE_RED: "/media/icons/bullet_close_red.svg",
  BULLET_REMOVE: "/media/icons/bullet_close_gray.svg",
  NOTE_VIEW_SUCCESS: "/media/icons/NoteView/note_view_success.svg",
  NOTE_VIEW_INFO: "/media/icons/NoteView/note_view_info.svg",
  NOTE_VIEW_COMPLETED: "/media/icons/NoteView/note_view_completed.svg",
  NOTE_VIEW_PRIMARY: "/media/icons/NoteView/note_view_primary.svg",
  NOTE_VIEW_DANGER: "/media/icons/NoteView/note_view_danger.svg",
  NOTE_VIEW_WARNING: "/media/icons/NoteView/note_view_warning.svg",
  NOTE_VIEW_WARNING_D9913D: "/media/icons/NoteView/note_view_warning_D9913D.svg",
  NOTE_VIEW_WARNING_TRIANGEL: "/media/icons/NoteView/note_view_danger_triangle.svg",
  INCOME: "/media/icons/income.svg",
  MENU_SO: "/media/icons/menu_so.svg",
  UPLOAD_CLOUD: "/media/icons/upload_cloud.svg",
  PROFILE_MAC: "/media/icons/profile_mac.svg",
  USER_MAC: "/media/icons/user_mac.svg",
  DETAPROFILE_MAC: "/media/icons/profile.svg",
  PLANT_SPRAYING: "/media/icons/plant_spraying.svg",
  ACCOUNT: "/media/icons/account.svg",
  PHONE: "/media/icons/phone.svg",
  MITRA_SMALL: "/media/icons/mitra_small.svg",
  MITRA_GREEN: "/media/icons/mitra_green.svg",
  FARMER_GREEN: "/media/icons/farmer_green.svg",
  DRONE_SPRAYING: "/media/icons/drone_spraying.svg",
  PIN_LOCATION: "/media/icons/pin_location.svg",
  ADDED: "/media/icons/added.svg",
  CLOSE: "/media/icons/close_icon.svg",
  SUCCESS: "/media/icons/success.svg",
  MAP: "/media/icons/map.svg",
  BASECAMP: "/media/icons/basecamp.svg",
  QUICK_ACTION_ADD: "/media/icons/quick_action_add.svg",
  FREEZE_STATUS: "/media/icons/freeze_status.svg",
  BLACKLIST_STATUS: "/media/icons/blacklist_status.svg",
  AREA_CHECK: "/media/icons/area_check.svg",
  SUB_MENU_ADD: {
    ADD_FARMER: "/media/icons/side-menu/farmer.svg",
    ADD_MITRA: "/media/icons/mitra.svg",
    ADD_FO: "/media/icons/side-menu/field_officer.svg",
    ADD_OPS_TEAM: "/media/icons/side-menu/operations_team.svg",
    ADD_USER_CMS: "/media/icons/account_cms.svg",
    ADD_LAND_CLEARING: "/media/icons/side-menu/bongkar.svg",
    ADD_INCORRECT_VARIETY: "/media/icons/side-menu/incorrect_variety.svg"
  },
  PIN_LOCATION_2: "/media/icons/pin_location_2.svg",
  MENU_CALENDAR: "/media/icons/side-menu/menu_calendar.svg",
  CALENDER_INPUT: "/media/icons/calendar_input.svg",
  REGIONAL: "/media/icons/regional.svg",
  PACKAGE: "/media/icons/package.svg",
  REMOVE: "/media/icons/delete.svg",
  REMOVE_OUTLINE_WHITE: "/media/icons/delete_outline_white.svg",
  SUBMISSION_AND_BLOCK: "/media/icons/sub_regional.svg",
  BACK: "/media/icons/arrow_line_left.svg",
  LOCATION: "/media/icons/location.svg",
  LOCATION_RED: "/media/icons/location_red.svg",
  MITRA: "/media/icons/mitra_gray.svg",
  MITRA_2: "/media/icons/mitra.svg",
  //Calendar
  CALENDER_OLD: "/media/icons/calendar_old.svg",
  CALENDER_BIG: "/media/icons/calendar_big.svg",
  CALENDER_GRAY: "/media/icons/calendar_gray.svg",
  CALENDER_OUTLINE: "/media/icons/calendar_outline.svg",
  MARKER_TRANSPARENT: "/media/icons/marker_transparan.png",
  ARROW_EXPAND: "/media/icons/arrow_left.svg",
  ARROW_BACK: "/media/icons/arrow_left_gray.svg",
  AREA: "/media/icons/area.svg",
  AREA_WHITE: "/media/icons/area_white.svg",
  ARROW_RIGHT_WHITE: "/media/icons/arrow_right_white.svg",
  SUB_REGIONAL: "/media/icons/sub_regional_outline.svg",
  INFO: "/media/icons/nothing.svg",
  WARNING: "/media/icons/warning.svg",
  MAP_WHITE: "/media/icons/Map/map_white.svg",
  MAP_AREA: "/media/icons/Map/map_area.svg",
  LOADING: "/media/gif/loader.gif",
  SUB_REGIONAL_WHITE: "/media/icons/sub_regional_white.svg",
  SIDE_MENU: {
    FARMER: "/media/icons/side-menu/farmer.svg",
    MITRA: "/media/icons/side-menu/mitra.svg",
    FO: "/media/icons/side-menu/field_officer.svg",
    OPERATIONS_TEAM: "/media/icons/side-menu/operations_team.svg",
    AREA: "/media/icons/side-menu/area.svg",
    ORDER: "/media/icons/side-menu/menu_calendar.svg",
    SUBMISSION: "/media/icons/side-menu/spk.svg",
    MAC: "/media/icons/side-menu/mac.svg",
    SETTING: "/media/icons/side-menu/option.svg",
    MASTER: "/media/icons/side-menu/data_management.svg",
    MAP_LEAD: "/media/icons/side-menu/map_lead.svg",
    ACTIVITY: "/media/icons/side-menu/activity.svg"
  },
  CORN: "/media/icons/corn.svg",
  CORN_O: "/media/icons/corn_o.svg",
  CORN_O_GRAY: "/media/icons/corn_o_gray.svg",
  PADDY_O: "/media/icons/paddy_o.svg",
  PADDY_O_GRAY: "/media/icons/paddy_o_gray.svg",
  SESSION: "/media/icons/session.svg",
  MAP_PROFILE: "/media/icons/map_profile.svg",
  WATER_IRRIGATION: "/media/icons/water_irigation.svg",
  FARMER_BIG: "/media/icons/farmer_big.svg",
  DOCUMENT: "/media/icons/document.svg",
  FAILUR_HARVEST: "/media/icons/rounded_failure_harvest.svg",
  INFO_2: "/media/icons/info.svg",
  PADDY: "/media/icons/paddy.svg",
  CALENDAR_DATE: "/media/icons/calendar_date.svg",
  GENDER: "/media/icons/gender.svg",
  SYNC: "/media/icons/action/sync.svg",
  ROLE_ACCESS: "/media/icons/role_access.svg",
  BANK: "/media/icons/bank.svg",
  REKENING: "/media/icons/reg.svg",
  BANK_ACCOUNT: "/media/icons/bank_account.svg",
  ARROW_UP: "/media/icons/arrow_up.svg",
  ARROW_DOWN: "/media/icons/arrow_down.svg",
  ZOOM_IN: "/media/icons/zoom_in.svg",
  ZOOM_OUT: "/media/icons/zoom_out.svg",
  ROTATE_LEFT: "/media/icons/rotate_left.svg",
  ROTATE_RIGHT: "/media/icons/rotate_right.svg",
  DOCUMENT_WHITE: "/media/icons/document_white.svg",
  //reset
  RESET_OUTLINE: "/media/icons/reset_outline.svg",
  ARROW_COLLAPE: "/media/icons/arrow_collaps.svg",
  MINI_CLOSE: "/media/icons/mini_close.svg",
  CLOSE_GREEN: "/media/icons/bullet_close_green.svg",
  DETAIL: "/media/icons/detail.svg",
  EDIT_LIST: "/media/icons/edit.svg",
  FIELD_UNASSIGN: "/media/icons/field_unassign.svg",
  PLAY: "/media/icons/play.svg",
  INVENTORY: "/media/icons/inventory.svg",
  IDEA: "/media/icons/idea.svg",
  LAND_AREA_WHITE: "/media/icons/map_white.svg",
  QUICK_ACCESS: "/media/icons/quick_access.svg",
  BLOCK: "/media/icons/side-menu/block.svg",
  BLOCK_AREA: "/media/icons/block_area.svg",
  PASS_LAND: "/media/icons/pass_land.svg",
  ARROW_RIGHT_GREEN: "/media/icons/arrow_line_right.svg",
  ARROW_RIGHT_DARK: "/media/icons/arrow_right_dark.svg",
  ARROW_LEFT_DARK: "/media/icons/arrow_left_dark.svg",
  DASHBOARD: "/media/icons/dashboard.svg",
  SEARCH: "/media/icons/search.svg",
  SEARCH_WHITE: "/media/icons/search_white.svg",
  APPROVAL: "/media/icons/approval.svg",
  FILTER: "/media/icons/filter.svg",
  FILTER_WHITE: "/media/icons/filter_white.svg",
  UPLOAD: "/media/icons/upload.svg",
  ADD_IMAGE: "/media/icons/add_image.svg",
  DANGER: "/media/icons/danger.svg",
  APPLICATION: "/media/icons/application.svg",
  DIRECTION: "/media/icons/directions.svg",
  DIRECTION_WHITE: "/media/icons/directions_white.svg",
  //Reset Only
  RESET_ONLY: "/media/icons/reset.svg",
  MARKER_LEAD: "/media/icons/marker_lead.svg",
  MARKER_PENDING: "/media/icons/marker_pending.svg",
  MARKER_APPROVED: "/media/icons/marker_terverifikasi.svg",
  MARKER_UNASSIGN: "/media/icons/marker_unassign.svg",
  MARKER_REJECT: "/media/icons/marker_reject.svg",
  MARKER_BASECAMP: "/media/icons/marker_basecamp.svg",
  LAND_FARMER: "/media/icons/farmer_lahan.svg",
  LINK_TO: "/media/icons/link_to.svg",
  FOCUS: "/media/icons/focuse.svg",
  MARKER_MITRA: "/media/icons/marker_mitra.svg",
  CUSTOMER_SERVICE: "/media/icons/ic_customer_service_default.svg",
  ACTION: {
    MITRA: "/media/icons/action/mitra.svg",
    FARMER: "/media/icons/action/farmer.svg",
    ADD: "/media/icons/action/bullet_plus.svg",
    CALENDER: "/media/icons/action/calendar.svg",
    HARVEST: "/media/icons/action/harvest.svg",
    SYNC: "/media/icons/action/sync.svg",
    SUSPEND: "/media/icons/action/suspend.svg",
    BULLET_CLOSE_OUTLINE: "/media/icons/action/bullet_close_outline.svg",
    PAUSE: "/media/icons/action/pause.svg",
    BLACKLIST: "/media/icons/action/blacklist.svg",
    UNFREEZE: "/media/icons/action/unfreeze.svg",
  },
  PHASE: {
    PHASE_PRELIMINARY: "/media/icons/phase/phase_preliminary.svg",
    PHASE_VEGETATIVE: "/media/icons/phase/phase_vegetative.svg",
    PHASE_FLOWERING: "/media/icons/phase/phase_flowering.svg",
    PHASE_RIPE: "/media/icons/phase/phase_ripe.svg",
    PHASE_HARVEST: "/media/icons/phase/phase_harvest.svg"
  },
  QA_ACTIVITY: {
    FLOWERING: "/media/icons/qa-activity/flowering.svg",
    HARVEST: "/media/icons/qa-activity/harvest.svg",
    PRELIMINARY: "/media/icons/qa-activity/preliminary.svg",
    RIPE: "/media/icons/qa-activity/ripe.svg",
    VEGETATIVE: "/media/icons/qa-activity/vegetative.svg",
    SUBMISSION: "/media/icons/qa-activity/submission.svg"
  },
  ACTIVITY_ICONS: {
    HARVEST_ESTIMATION: "/media/icons/activity/estimasi_panen.svg",
    TILLAGE: "/media/icons/activity/olah_tanah.svg",
    HARVEST: "/media/icons/activity/panen.svg",
    PLANTING: "/media/icons/activity/penanaman.svg",
    SPRAYING: "/media/icons/activity/penyemprotan.svg",
    SEEDLING: "/media/icons/activity/semai.svg",
    FERTILIZATION: "/media/icons/activity/pemupukan.svg",
    HARVEST_FAILURE: "/media/icons/activity/harvest_failure.svg",
    HATCHERY: "/media/icons/activity/lahan_pembenihan.svg",
    LAND_CLEARING: "/media/icons/activity/land_clearing.svg",
    BASECAMP: "/media/icons/activity/basecamp.svg"
  }
}

export const LOGOS_CONSTANT = {
  MAI: "/media/logos/logo-mai.png"
}
